import { storage } from "@/firebase"

/**
 * Upload de arquivo PDF da conta de água para um histórico específico
 * @param {string} idProject - ID do projeto
 * @param {string} idHistoric - ID do histórico
 * @param {File} file - Arquivo a ser enviado
 * @returns {Promise<string>} - Caminho do arquivo no Storage
 */
const uploadFile = async (idProject, idHistoric, file) => {
    try {
        const allowedTypes = ["application/pdf"];
        if (!allowedTypes.includes(file.type)) {
            throw new Error("Somente arquivos PDF são permitidos.");
        }

        const fileName = `${new Date().getTime()}_${file.name}`;
        const filePath = `project_historics/${idProject}/${idHistoric}/${fileName}`;

        const storageRef = storage.ref(filePath);
        const uploadTask = storageRef.put(file);

        await new Promise((resolve, reject) => {
            uploadTask.on(
                "state_changed",
                function progress(snapshot) {
                    const percentage = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    console.log(`Upload progress: ${percentage}%`);
                },
                function error(err) {
                    console.error(`uploadFile - ${err}`);
                    reject(err);
                },
                function complete() {
                    resolve();
                }
            );
        });

        return filePath;
    } catch (error) {
        console.error("Erro ao fazer upload do arquivo do histórico:", error.message);
        throw error;
    }
}

/**
 * Download de arquivo do histórico
 * @param {string} path - Caminho do arquivo no Storage
 * @returns {Promise<Blob>} - Blob do arquivo
 */
const downloadFile = async (path) => {
    try {
        const fileRef = storage.ref(path);
        const downloadURL = await fileRef.getDownloadURL();
        const response = await fetch(downloadURL);
        const blob = await response.blob();
        return blob;
    } catch (error) {
        console.error("Erro ao fazer download do arquivo do histórico:", error);
        throw error;
    }
}

/**
 * Obter URL de download direto
 * @param {string} path - Caminho do arquivo no Storage
 * @returns {Promise<string>} - URL de download
 */
const getDownloadURL = async (path) => {
    try {
        const fileRef = storage.ref(path);
        const downloadURL = await fileRef.getDownloadURL();
        return downloadURL;
    } catch (error) {
        console.error("Erro ao obter URL de download:", error);
        throw error;
    }
}

/**
 * Deletar arquivo do histórico
 * @param {string} path - Caminho do arquivo no Storage
 * @returns {Promise<void>}
 */
const deleteFile = async (path) => {
    try {
        if (!path) return;
        await storage.ref(path).delete();
        console.log(`Arquivo deletado: ${path}`);
    } catch (err) {
        console.error(`Error - deleteFile ${err}`);
        // Não lançar erro se o arquivo não existir
        if (err.code !== 'storage/object-not-found') {
            throw err;
        }
    }
}

export default {
    uploadFile,
    downloadFile,
    getDownloadURL,
    deleteFile
}

